import classNames from 'classnames';
import Button from 'components/base/Button';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faFileSignature, faLanguage, faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import ResourceTranscriptionModal from './ResourceTranscriptionModal';
import { ResourceTranscriptionInfo } from './DataDefinitions';
import { getLanguageFromCode } from 'helpers/utils';

const AboutResourceCard = ({ data, className, onSave }: {
  data?: ResourceTranscriptionInfo, className?: string,
  onSave?: (filename: string, language: string, isSpeakerACoach: boolean, isSpeakerBCoach: boolean) => void;
}) => {


  const [showEditFileModal, setShowEditFileModal] = useState(false);
  const handleEditFileCloseModal = () => {
    setShowEditFileModal(false);
  };

  const handleSave = (filename: string, language: string, isSpeakerACoach: boolean, isSpeakerBCoach: boolean) => {
    setShowEditFileModal(false);
    if (onSave)
      onSave(filename, language, isSpeakerACoach, isSpeakerBCoach);
  };


  return (

    <>
      <ResourceTranscriptionModal show={showEditFileModal} onSave={handleSave} onClose={handleEditFileCloseModal} data={data} />
      <Card className={classNames(className, 'w-100')}>
        <Card.Body className='ps-2 pt-2'>

          <div className="d-flex p-1 mt-1 ">
            <div className="d-flex align-items-center" style={{ width: '35%' }}>
              <FontAwesomeIcon icon={faFileSignature} />
              <h5 className="text-1000 ms-2">Filename:</h5>
            </div>
            <p className="text-primary ms-2 fs-8 card-text ">{data?.resource.resource_name}</p>
          </div>

          <div className="d-flex p-1">
            <div className="d-flex align-items-center" style={{ width: '35%' }}>
              <FontAwesomeIcon icon={faLanguage} />
              <h5 className="text-1000 ms-2">Language:</h5>
            </div>
            <h5 className="text-primary ms-2 fs-8 card-text">{getLanguageFromCode(data?.transcription.language ?? '-')}</h5>
          </div>

          <div className="d-flex p-1">
            <div className="d-flex align-items-center" style={{ width: '35%' }}>
              <FontAwesomeIcon icon={faPeopleGroup} />
              <h5 className="text-1000 ms-2"># of Speakers:</h5>
            </div>
            <h5 className="text-primary ms-2 fs-8 card-text">{data?.transcription.number_of_speakers ?? '-'}</h5>
          </div>


          {data?.transcription.number_of_speakers && parseInt(data?.transcription.number_of_speakers) > 2 ?
            (<> </>) :
            (<>
              <div className="d-flex p-1">
                <div className="d-flex align-items-center" style={{ width: '35%' }}>
                  <FontAwesomeIcon icon={faUser} />
                  <h5 className="text-1000 ms-2">Speaker A:</h5>
                </div>
                <h5 className="text-primary ms-2 fs-8 card-text">{data?.transcription.speakerA ?? '-'}</h5>
              </div>

              <div className="d-flex p-1">
                <div className="d-flex align-items-center" style={{ width: '35%' }}>
                  <FontAwesomeIcon icon={faUser} />
                  <h5 className="text-1000 ms-2">Speaker B:</h5>
                </div>
                <h5 className="text-primary ms-2 fs-8 card-text">{data?.transcription.speakerB ?? '-'}</h5>
              </div>

              <div className="d-flex mt-1 flex-row-reverse">
                <Button variant="primary" onClick={() => setShowEditFileModal(true)}>Edit</Button>
              </div>
            </>)
          }

        </Card.Body>
      </Card>
    </>
  );
};

export default AboutResourceCard;
